export const menus = [
  {
    sortBy: "category",
    active: true,
    _id: "4",
    purposeType: "website",
    websitePurpose: "dailyMenu",
    name: "Friday",
    description: "",
    menuDate: "2020-09-25",
    dishes: [
      {
        _id: "5f6d739a3854b07e2575363f",
        quantity: 10,
        dishBody: {
          _id: "1",
          category: "SALAD",
          subcategory: "Meat salad",
          name: "Special beef salad",
          serving: "150",
          price: 4.5,
          calories: 200,
          description: "Beef, salad",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753640",
        quantity: 10,
        dishBody: {
          _id: "3",
          category: "SALAD",
          subcategory: "Vegetarian salad",
          name: "Tomato salad",
          serving: "150",
          price: 3,
          calories: 100,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753641",
        quantity: 10,
        dishBody: {
          _id: "5",
          category: "MAIN",
          subcategory: "Burgers",
          name: "Special beef burger",
          serving: "400",
          price: 10,
          calories: 500,
          description: "Our very special burger",
          composition: "Beef, dough, milk, green salad"
        }
      },
      {
        _id: "5f6d739a3854b07e25753642",
        quantity: 10,
        dishBody: {
          _id: "7",
          category: "MAIN",
          subcategory: "Steaks",
          name: "Beef steak",
          serving: "400",
          price: 14,
          calories: 500,
          description: "Our very special burger",
          composition: "Beef"
        }
      },
      {
        _id: "5f6d739a3854b07e25753643",
        quantity: 10,
        dishBody: {
          _id: "9",
          category: "SIDE DISHES",
          subcategory: "Potatoes",
          name: "Baked potatoes",
          serving: "150",
          price: 3,
          calories: null,
          description: "",
          composition: "",
          pictureURL: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753644",
        quantity: 10,
        dishBody: {
          _id: "10",
          category: "SIDE DISHES",
          subcategory: "Mushrooms",
          name: "Fried mushrooms",
          serving: "150",
          price: 4,
          calories: null,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753645",
        quantity: 10,
        dishBody: {
          _id: "12",
          category: "DESSERTS",
          subcategory: "Ice cream",
          name: "Special vanilla ice cream",
          serving: "150",
          price: 10,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753646",
        quantity: 10,
        dishBody: {
          category: "BEVERAGES",
          subcategory: "Non-alcoholic",
          name: "Soda",
          _id: "14",
          serving: "150",
          price: 3,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753647",
        quantity: 10,
        dishBody: {
          _id: "13",
          category: "BEVERAGES",
          subcategory: "Non-alcoholic",
          name: "Green tea",
          serving: "150",
          price: 3,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753648",
        quantity: 10,
        dishBody: {
          category: "OTHER",
          subcategory: "",
          name: "Disposable tableware",
          _id: "17",
          serving: "1",
          price: 1,
          calories: null,
          description: "",
          composition: "",
          pictureURL: ""
        }
      }
    ],
    __v: 161
  },
  {
    sortBy: "category",
    active: false,
    _id: "5",
    purposeType: "print",
    websitePurpose: "",
    name: "Friday",
    description: "",
    menuDate: "2020-09-25",
    dishes: [
      {
        _id: "5f6d739a3854b07e2575363f",
        quantity: 10,
        dishBody: {
          _id: "1",
          category: "SALAD",
          subcategory: "Meat salad",
          name: "Special beef salad",
          serving: "150",
          price: 4.5,
          calories: 200,
          description: "Beef, salad",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753640",
        quantity: 10,
        dishBody: {
          _id: "3",
          category: "SALAD",
          subcategory: "Vegetarian salad",
          name: "Tomato salad",
          serving: "150",
          price: 3,
          calories: 100,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753641",
        quantity: 10,
        dishBody: {
          _id: "5",
          category: "MAIN",
          subcategory: "Burgers",
          name: "Special beef burger",
          serving: "400",
          price: 10,
          calories: 500,
          description: "Our very special burger",
          composition: "Beef, dough, milk, green salad"
        }
      },
      {
        _id: "5f6d739a3854b07e25753642",
        quantity: 10,
        dishBody: {
          _id: "7",
          category: "MAIN",
          subcategory: "Steaks",
          name: "Beef steak",
          serving: "400",
          price: 14,
          calories: 500,
          description: "Our very special burger",
          composition: "Beef"
        }
      },
      {
        _id: "5f6d739a3854b07e25753643",
        quantity: 10,
        dishBody: {
          _id: "9",
          category: "SIDE DISHES",
          subcategory: "Potatoes",
          name: "Baked potatoes",
          serving: "150",
          price: 3,
          calories: null,
          description: "",
          composition: "",
          pictureURL: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753644",
        quantity: 10,
        dishBody: {
          _id: "10",
          category: "SIDE DISHES",
          subcategory: "Mushrooms",
          name: "Fried mushrooms",
          serving: "150",
          price: 4,
          calories: null,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753645",
        quantity: 10,
        dishBody: {
          _id: "12",
          category: "DESSERTS",
          subcategory: "Ice cream",
          name: "Special vanilla ice cream",
          serving: "150",
          price: 10,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753646",
        quantity: 10,
        dishBody: {
          _id: "14",
          category: "BEVERAGES",
          subcategory: "Non-alcoholic",
          name: "Soda",
          serving: "150",
          price: 3,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753647",
        quantity: 10,
        dishBody: {
          _id: "13",
          category: "BEVERAGES",
          subcategory: "Non-alcoholic",
          name: "Green tea",
          serving: "150",
          price: 3,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e25753648",
        quantity: 10,
        dishBody: {
          _id: "16",
          category: "BEVERAGES",
          subcategory: "Alcoholic",
          name: "Wine",
          serving: "300",
          price: 10,
          calories: 500,
          description: "",
          composition: ""
        }
      },
      {
        _id: "5f6d739a3854b07e257asdasd53648",
        quantity: 10,
        dishBody: {
          _id: "15",
          category: "BEVERAGES",
          subcategory: "Alcoholic",
          name: "Whiskey",
          serving: "100",
          price: 8,
          calories: 500,
          description: "",
          composition: ""
        }
      }
    ],
    __v: 161
  },
  {
    sortBy: "category",
    active: true,
    _id: "1",
    purposeType: "website",
    websitePurpose: "static",
    name: "Special menu",
    description: "Our very special dishes",
    menuDate: "2020-07-23",
    dishes: [
      {
        _id: "5f270c893854b07e257478f2",
        quantity: 0,
        dishBody: {
          _id: "18",
          category: "SPECIAL",
          subcategory: "",
          name: "Roasted whole pig",
          serving: "4000",
          price: 150,
          calories: null,
          description: "",
          composition: "",
          pictureURL: "",
          __v: 0
        }
      },
      {
        _id: "5f270c893854b07e257478f3",
        quantity: 0,
        dishBody: {
          _id: "19",
          category: "SPECIAL",
          subcategory: "",
          name: "Baked duck",
          serving: "2000",
          price: 90,
          calories: null,
          description: "",
          composition: "",
          pictureURL: "",
          __v: 0
        }
      }
    ],
    __v: 2
  },
  {
    sortBy: "subcategory",
    active: true,
    _id: "2",
    purposeType: "website",
    websitePurpose: "orderMenu",
    name: "Salads",
    description: "All of our salads",
    menuDate: "2020-08-02",
    dishes: [
      {
        _id: "5f43f0a23854b07e2574ce5d",
        quantity: 10,
        dishBody: {
          _id: "1",
          category: "SALAD",
          subcategory: "Meat salad",
          name: "Special beef salad",
          serving: "150",
          price: 4.5,
          calories: 200,
          description: "Beef, salad",
          composition: "",
          __v: 0
        }
      },
      {
        _id: "5f43f0a23854b07e2574ce5e",
        quantity: 10,
        dishBody: {
          _id: "2",
          category: "SALAD",
          subcategory: "Meat salad",
          name: "Chicken salad",
          serving: "150",
          price: 4.5,
          calories: 200,
          description: "",
          composition: "",
          __v: 0
        }
      },
      {
        _id: "5f43f0a23854b07e2574ce5f",
        quantity: 10,
        dishBody: {
          _id: "3",
          category: "SALAD",
          subcategory: "Vegetarian salad",
          name: "Tomato salad",
          serving: "150",
          price: 3,
          calories: 100,
          description: "",
          composition: "",
          __v: 0
        }
      },
      {
        _id: "5f43f0a23854b07e2574ce60",
        quantity: 10,
        dishBody: {
          _id: "4",
          category: "SALAD",
          subcategory: "Vegetarian salad",
          name: "Cucumber salad",
          serving: "150",
          price: 3,
          calories: 100,
          description: "",
          composition: "",
          __v: 0
        }
      }
    ],
    __v: 7
  },
  {
    sortBy: "category",
    active: false,
    _id: "3",
    purposeType: "website",
    websitePurpose: "orderMenu",
    name: "Main dishes",
    description: "",
    menuDate: "2020-08-02",
    dishes: [
      {
        _id: "5f43f1ca3854b07e2574ce84",
        quantity: 10,
        dishBody: {
          _id: "5",
          category: "MAIN",
          subcategory: "Burgers",
          name: "Special beef burger",
          serving: "400",
          price: 10,
          calories: 500,
          description: "Our very special burger",
          composition: "Beef, dough, milk, green salad",
          __v: 0
        }
      },
      {
        _id: "5f43f1ca3854b07e2574ce85",
        quantity: 10,
        dishBody: {
          _id: "6",
          category: "MAIN",
          subcategory: "Burgers",
          name: "Special chicken burger",
          serving: "350",
          price: 9,
          calories: 400,
          description: "Our very special burger",
          composition: "Chicken, dough, milk, green salad"
        }
      },
      {
        _id: "5f43f1ca3854b07e2574ce86",
        quantity: 10,
        dishBody: {
          _id: "7",
          category: "MAIN",
          subcategory: "Steaks",
          name: "Beef steak",
          serving: "400",
          price: 14,
          calories: 500,
          description: "Our very special burger",
          composition: "Beef"
        }
      }
    ],
    __v: 5
  }
];
